const r = {
  map: "light",
  hybrid: "dark",
  arcGisImagery: "dark",
  arcGisStreets: "light",
  arcGisTerrain: "light",
  esriHybrid: "dark",
  esriStreets: "light"
}, e = "https://storage.googleapis.com/guru_media/arc-gis-basemaps-style", a = {
  map: {
    label: "Map",
    value: "map",
    sourceUrl: "mapbox://styles/devops-placer/clrjvslmc001401qqfah3alv6",
    beforeId: "road-label"
  },
  hybrid: {
    label: "Hybrid",
    value: "hybrid",
    sourceUrl: "mapbox://styles/devops-placer/clrp9rlyt006j01p2621b6cv6",
    beforeId: "road-label"
  },
  arcGisImagery: {
    label: "Esri Imagery Hybrid",
    value: "arcGisImagery",
    sourceUrl: `${e}/world-imagery-basemap-osm.json`,
    beforeId: "service road/label/Default"
  },
  arcGisStreets: {
    label: "OpenStreetMap",
    value: "arcGisStreets",
    sourceUrl: `${e}/streets-basemap-osm.json`,
    beforeId: "other path/label/Default"
  },
  arcGisTerrain: {
    label: "World Hillshade",
    value: "arcGisTerrain",
    sourceUrl: `${e}/terrain-basemap-osm.json`,
    beforeId: "other path/label/Default"
  },
  esriHybrid: {
    label: "Esri Imagery Hybrid",
    value: "esriHybrid",
    sourceUrl: `${e}/hybrid-basemap-esri-barlow-v7.json`,
    beforeId: "Road/label/Shield/AU/Highway"
  },
  esriStreets: {
    label: "Esri Streets",
    value: "esriStreets",
    sourceUrl: `${e}/streets-basemap-esri-barlow-v11.json`,
    beforeId: "Road tunnel/label/Pedestrian"
  }
};
export {
  r as BASEMAP_STYLE_MAPPING,
  a as MB_BASEMAP_MAPPING
};
//# sourceMappingURL=index.es117.js.map
